<template>
  <form action="" name="@@form-name">
    <div class="damage-area-container damage-area--small">
      <fieldset class="checkbox-inline">
        <div v-for="(damageZone, index) in options" :key="index">
          <input
            :id="'damage-area--' + id + '-' + damageZone.Id + '-mobile'"
            v-model="selectedDamageZones"
            :value="damageZone"
            :data-test="'damage-area--' + id + '-' + damageZone.Name"
            type="checkbox"
          />
          <label :for="'damage-area--' + id + '-' + damageZone.Id + '-mobile'">{{
            damageZone.ButtonText
          }}</label>
        </div>
      </fieldset>
    </div>
    <div class="damage-area-container damage-area--medium">
      <div :style="background" class="square damage-area">
        <label
          v-for="(damageZone, index) in upperOptions"
          :key="index"
          :for="'damage-area--' + id + '-' + damageZone.Id"
          :data-test="'damage-area--' + id + '-' + damageZone.Name"
          :class="'checkbox-button damage-area--' + damageZone.Name"
        >
          <input
            :id="'damage-area--' + id + '-' + damageZone.Id"
            v-model="selectedDamageZones"
            :value="damageZone"
            type="checkbox"
          />
          <span class="button primary">{{ damageZone.ButtonText }}</span>
        </label>
      </div>

      <br />
      <br />

      <div class="row push-up">
        <label
          v-for="(damageZone, index) in lowerOptions"
          :key="index"
          :for="'damage-area--' + id + '-' + damageZone.Id"
          :data-test="'damage-area--' + id + '-' + damageZone.Name"
          :class="'checkbox-button damage-area--' + damageZone.Name + ' small-6 medium-4 columns'"
        >
          <input
            :id="'damage-area--' + id + '-' + damageZone.Id"
            v-model="selectedDamageZones"
            :value="damageZone"
            type="checkbox"
          />
          <span class="button primary">{{ damageZone.ButtonText }}</span>
        </label>
      </div>
    </div>
    <Field
      v-model="selectedLength"
      v-slot="{ field }"
      :rules="'min_value:1|max_value:8'"
      :name="'damage-zones-' + id"
    >
      <input v-bind="field" type="hidden" />
      <ValidationError
        :name="'damage-zones-' + id"
        :overrides="{
          max_value: 'Har du mere end 8 skadezoner, skal du i stedet vælge &quot;Overalt&quot;.',
          min_value: 'Du skal vælge mindst én skadezone'
        }"
        :errors="errors"
      />
    </Field>
  </form>
</template>

<script>
import Utility from '@/common/UtilityFunctions.js';
import ValidationError from '@/components/UI/ValidationError.vue';

export default {
  name: 'DamageZones',
  emits: ['update:modelValue', 'show-minor-damage-question'],
  components: {
    ValidationError
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    errors: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      selectedDamageZones: []
    };
  },
  computed: {
    background() {
      return (
        "background-image: url('/assets/portal/images/damagezones/" +
        Utility.getBrandFolderName() +
        "/Bil.svg')"
      );
    },
    upperOptions() {
      return this.options.slice(0, 11);
    },
    lowerOptions() {
      return this.options.slice(11);
    },
    selectedLength() {
      return this.selectedDamageZones.length;
    },
    showMinorDamageQuestion() {
      const incompatibleCount = this.selectedDamageZones.filter(o => o.IsCarbucksCompatible === false).length;
      const compatibleCount = this.selectedDamageZones.filter(o => o.IsCarbucksCompatible === true).length;
      return incompatibleCount === 0 && compatibleCount < 3;
    }
  },
  watch: {
    selectedDamageZones() {
      if (!this.selectedDamageZones.length) return;

      const lastItemIsOveralt = this.selectedDamageZones.at(-1)?.Name === 'overalt';
      const anyItemIsOveralt = this.selectedDamageZones.some((i) => i.Name === 'overalt');

      this.selectedDamageZones.splice(
        0,
        lastItemIsOveralt ? this.selectedDamageZones.length - 1 : anyItemIsOveralt ? 1 : 0
      );

      this.$emit('update:modelValue', this.selectedDamageZones);
    },
    showMinorDamageQuestion() {
      this.$emit('show-minor-damage-question', this.showMinorDamageQuestion);
    }
  },
  mounted() {
    this.selectedDamageZones = this.$attrs.modelValue;
  }
};
</script>

<style lang="scss" scoped>
@import 'src/styles/all';
.square {
  position: relative;
  width: 100%;
  padding-bottom: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.damage-area {
  position: relative;

  &--small {
    display: none;

    @media screen and (max-width: 321px) {
      display: block !important;
    }
  }

  &--medium {
    @media screen and (max-width: 320px) {
      display: none !important;
    }
  }

  .button {
    @include breakpoint(small only) {
      padding: rem-calc(0 30 0 15) !important;
    }
  }

  > label {
    position: absolute;
    width: 30%;

    &[class*='venstre'] {
      left: 0;
    }

    &[class*='hoejre'] {
      right: 0;
    }
  }

  &--front,
  &--forrude,
  &--tag,
  &--bagrude,
  &--bagparti {
    left: 50%;
    transform: translateX(-50%);
  }

  &--front {
    top: 0;
  }

  &--forrude {
    top: 20%;
  }

  &--tag {
    top: 50%;
  }

  &--bagrude {
    top: 70%;
  }

  &--bagparti {
    bottom: rem-calc(-15);
  }

  &--venstre-side-for,
  &--hoejre-side-for {
    top: 15%;
  }

  &--venstre-side-midt,
  &--hoejre-side-midt {
    top: 50%;
  }

  &--venstre-side-bag,
  &--hoejre-side-bag {
    top: 80%;
  }
}
</style>
